// import { cn } from '@lib/utils'
import { NavLink } from 'react-router-dom'
// import { useAuthStore } from '@core/auth/auth.store'
import { useAbility } from '@core/permissions/ability'

interface SidebarProps {
  position: 'left' | 'right'
}

export function Sidebar({ position }: SidebarProps) {
  // const { user } = useAuthStore()
  const ability = useAbility()

  const menuItems = [
    {
      title: 'Atención',
      path: '/atencion',
      permission: { action: 'read', subject: 'atencion' },
      icon: 'fas fa-user-md'
    },
    {
      title: 'Citas',
      path: '/citas',
      permission: { action: 'read', subject: 'citas' },
      icon: 'fas fa-calendar-alt'
    },
    {
      title: 'Calendario',
      path: '/calendario',
      permission: { action: 'read', subject: 'calendario' },
      icon: 'fas fa-calendar-week'
    },
    {
      title: 'Configurar Flujos',
      path: '/flowconfig',
      permission: { action: 'read', subject: 'flowconfig' },
      icon: 'fas fa-project-diagram'
    },
    {
      title: 'Buzón de Citas',
      path: '/buzoncitas',
      permission: { action: 'read', subject: 'buzoncitas' },
      icon: 'fas fa-mail-bulk'
    },
    {
      title: 'Desbloquear Citas',
      path: '/desbloquearcita',
      permission: { action: 'read', subject: 'desbloquearcita' },
      icon: 'fas fa-mail-bulk'
    },
    {
      title: 'Clínicas',
      path: '/clinicas',
      permission: { action: 'read', subject: 'clinicas' },
      icon: 'fas fa-hospital'
    },
    {
      title: 'Doctores',
      path: '/doctores',
      permission: { action: 'read', subject: 'doctores' },
      icon: 'fas fa-user-md'
    },
  ]

  if (position === 'right') {
    return null // No renderizamos el sidebar derecho por ahora
  }

  return (
    <div className="sidebar sisbermenu">
      <div className="udsp_default">
        <div pantalla="MENUPRINCIPAL">

          <div className="d-flex" id="wrapper">

            <div className="sideBar" id="sidebar-wrapper">

              <div className="sidebar-heading primary-text">
                <img src={`${import.meta.env.BASE_URL}img/LogotipoSigma.svg`} style={{ cursor: 'pointer' }} onClick={() => {/* TODO: Implementar navegación */ }} />
              </div>

              <div className="" name="dinamicMenu">
              </div>

              <div className="w-100 m-2">
                <a className="list-group-item list-group-item-action py-2 ripple">
                  <i className="fas fa-ellipsis-h fa-fw me-3 d-inline-block"></i> Menú
                </a>
              </div>

              <hr />

              <div className="m-2">
                <a className="list-group-item list-group-item-action py-2 ripple d-flex align-items-center w-100" style={{ cursor: 'pointer', textDecoration: 'none' }}>
                  <div className="d-flex align-items-center" style={{ opacity: 0.7 }}>
                    <i className="fa fa-star" style={{ fontSize: '10px', marginRight: '8px' }}></i>
                    <p className="mb-0" style={{ fontSize: '13px' }}><i>Agregar módulos favoritos</i></p>
                  </div>
                </a>
              </div>

              <div className='w-100'>
                {menuItems.map((item) => {
                  if (!ability.can(item.permission.action, item.permission.subject)) {
                    return null
                  }

                  return (
                    <div key={item.path} className="btn-option-menu -uocc-">
                      <NavLink
                        to={item.path}
                        className="list-group-item list-group-item-action py-2 ripple d-flex justify-content-between align-items-center w-100"
                        style={{ cursor: 'pointer', textDecoration: 'none' }}
                      >
                        <span className=""></span>
                        <span className="w-100">{item.title}</span>
                      </NavLink>
                    </div>
                  )
                })}
              </div>

              <div>
                <img src="/img/Sello.png" className="sello" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}